var exports = {
  "lJ": "AttachmentMosaic.module__mosaicContainerWrapper___aDhYNk",
  "Yt": "AttachmentMosaic.module__mosaicContainer___aDhYNk",
};

module.exports = exports;
